import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { returnHome } from '../../actions/customerPortal';
import UserSettings from './UserSettings';
import UpdatePassword from './UpdatePassword';

export class UserSettingsContainer extends React.Component {
  static propTypes = {
    returnHomeAction: PropTypes.func.isRequired,
  };

  escapeForm = (isFormDirty = true, evt = false) => {
    if (isFormDirty) {
      // eslint-disable-next-line
      if (window.confirm('you are about to lose your changes, are you sure?')) {
        this.leaveForm(evt);
      }
    } else {
      this.leaveForm(evt);
    }
  };

  leaveForm = evt => {
    const { returnHomeAction } = this.props;
    if (evt !== false) {
      evt.preventDefault();
    }
    returnHomeAction();
  };

  render() {
    return (
      <div className="row">
        <div className="col-md-6 col-md-offset-3">
          <div className="container form-only">
            <p className="pull-right">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => this.escapeForm(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </p>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-block">
                  <h2 className="card-title">Account Settings</h2>
                  <div className="row">
                    <div className="col-xs-12">
                      <UserSettings />
                      <br />
                      <UpdatePassword />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, {
  returnHomeAction: returnHome,
})(UserSettingsContainer);
